// svg png 图片资源来自阿里字体库
// [阿里字体库](https://www.iconfont.cn/collections/index?spm=a313x.7781069.1998910419.4)
// svg图标建议使用自己创建的
import registerStart from './registerStart'
import registerUser from './registerUser'
import registerEnd from './registerEnd'
import registerPush from './registerPush'
import registerDownload from './registerDownload'
import registerPolyline from './registerPolyline'

export {
  registerStart,
  registerUser,
  registerEnd,
  registerPush,
  registerDownload,
  registerPolyline,
}
